import { render, staticRenderFns } from "./SingleClientKogi.vue?vue&type=template&id=7cfa5b93&scoped=true&"
import script from "./SingleClientKogi.vue?vue&type=script&lang=js&"
export * from "./SingleClientKogi.vue?vue&type=script&lang=js&"
import style0 from "./SingleClientKogi.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SingleClientKogi.vue?vue&type=style&index=1&id=7cfa5b93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfa5b93",
  null
  
)

export default component.exports